import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetTicketinghub as ExternalWidgetTicketinghubType } from "../../types/ExternalWidget";

export type ExternalWidgetTicketinghubProps = Pick<ExternalWidgetTicketinghubType, "widgetId"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
    onOpen?: () => void;
};

export function ExternalWidgetTicketinghub({ ButtonComponent, onOpen }: ExternalWidgetTicketinghubProps) {
    const [t] = useNextTranslation("externalWidget");
    const Button = ButtonComponent ?? ProductBookNowButton;

    return (
        <Button onClick={onOpen} data-button-text="Book Now">
            {t("ticketinghub.availabilityButton.label")}
        </Button>
    );
}
